/** Vollständiger Seitenwechsel (z. B. zu Google). In Tests ersetzbar. */
export function navigateTo(url: string): void {
  window.location.assign(url);
}
